export enum Channel {
  Shopapp = "shopApp",
  Pointofsale = "pointOfSale",
  Web = "web",
  Ai = "ai",
  Api = "api",
}
